export default "__VITE_ASSET__NskhZZUl__"